import { H3 } from '@liveauctioneers/hammer-ui-core/text';

type AttachFilesPlaceholderProps = {
    readonly testid?: string;
};

export const AttachFilesPlaceholder = ({ testid = 'messengerAttachFilesPlaceholder' }: AttachFilesPlaceholderProps) => (
    <>
        <div
            className="max-[560px]:hidden mx-[18px] mt-xs mb-[17px] flex flex-col items-center justify-center rounded-[10px] border-2 border-dashed border-text-inactive bg-surface-100 px-[18px] py-[23px] text-center [&_h3]:text-text-secondary"
            data-testid={testid}
        >
            <H3 as="h3">Drag and drop up to 5 images here</H3>
        </div>
        <div className="max-[560px]:h-xs" />
    </>
);
